import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  Components.addType("services", {
    model: {
      defaults: {
        draggable: true,
        droppable: false,
        components: /*html*/ `
          <div class="bg-[var(--primary)] py-4 md:py-12 lg:py-16 w-full my-4">
            <div class="max-w-7xl mx-auto px-3  md:px-8">
              <div
                class="flex md:grid md:grid-cols-3 md:gap-6 overflow-x-auto"
              >
                <div
                  class="flex items-center space-x-1 md:space-x-3 p-2 md:p-4 flex-shrink-0"
                >
                  <div
                    class="md:w-16 md:h-16 h-8 w-8 flex-shrink-0 flex items-center justify-center service-icon"
                  >
                  <img
                  src="https://via.placeholder.com/100"
                  alt="Category_img"
                  class="w-full h-full object-contain"
                   />
                  </div>
                  <span
                    class="md:text-[20px] text-sm font-semibold text-white service-title"
                  >
                    Fast Delivery
                  </span>
                </div>
                <div
                  class="flex items-center space-x-1 md:space-x-3 p-2 md:p-4 flex-shrink-0 "
                >
                  <div
                    class="md:w-16 md:h-16 h-8 w-8 flex-shrink-0 flex items-center justify-center service-icon"
                  >
                  <img
                  src="https://via.placeholder.com/100"
                  alt="Category_img"
                  class="w-full h-full object-contain"
                   />
                  </div>
                  <span
                    class="md:text-[20px] text-sm font-semibold text-white service-title"
                  >
                    Fair Prices
                  </span>
                </div>
                <div
                  class="flex items-center space-x-1 md:space-x-3 p-2 md:p-4 flex-shrink-0 "
                >
                  <div
                    class="md:w-16 md:h-16 h-8 w-8 flex-shrink-0 flex items-center justify-center service-icon"
                  >
                  <img
                  src="https://via.placeholder.com/100"
                  alt="Category_img"
                  class="w-full h-full object-contain"
                   />
                  </div>
                  <span
                    class="md:text-[20px] text-sm font-semibold text-white service-title"
                  >
                    Exclusive Discounts
                  </span>
                </div>
              </div>
            </div>
          </div>
        `,
        script: () => {
          const style = document.createElement("style");
          style.innerHTML = `
  ::-webkit-scrollbar {
    display: none;
  }
  body {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }
`;
          document.head.appendChild(style);
        },
        traits: [
          {
            type: "text",
            name: "icon",
            label: "Icon",
            changeProp: true,
          },
          {
            type: "text",
            name: "title",
            label: "Title",
            changeProp: true,
          },
        ],
        toolbar: [
          {
            attributes: { class: "fa fa-trash-o" },
            command: "tlb-delete",
          },
          {
            attributes: { class: "fa fa-gear" },
            command: "service-edit",
          },
        ],
      },
    },
  });
};
